import { SVGICON } from "../../constant/theme";

export const MenuList = [
    // Dashboard — standalone, no group
    {
        titleKey: 'nav.dashboard',
        iconStyle: SVGICON.Home,
        to: '/dashboard',
        moduleKey: 'dashboard',
    },
    // Materials — section
    {
        titleKey: 'nav.materials',
        iconStyle: SVGICON.MaterialLogs,
        content: [
            { titleKey: 'nav.materials', to: '/materials', moduleKey: 'materials' },
            { titleKey: 'nav.materialsStock', to: '/materials-stock', moduleKey: 'materials_stock' },
        ],
    },
    // Recipes — section
    {
        titleKey: 'nav.recipes',
        iconStyle: SVGICON.Forms,
        content: [
            { titleKey: 'nav.recipes', to: '/recipes', moduleKey: 'recipes' },
            { titleKey: 'nav.nutritionValues', to: '/recipes/nutrition-facts', moduleKey: 'nutrition_facts' },
        ],
    },
    // Products — section
    {
        titleKey: 'nav.production',
        iconStyle: SVGICON.trolly,
        content: [
            { titleKey: 'nav.production', to: '/products', moduleKey: 'products' },
            { titleKey: 'nav.productStock', to: '/products-stock', moduleKey: 'products_stock' },
        ],
    },
    // Orders — section
    {
        titleKey: 'nav.orders',
        iconStyle: SVGICON.TaskIcon,
        content: [
            { titleKey: 'nav.orders', to: '/orders', moduleKey: 'orders' },
            { titleKey: 'nav.orderStats', to: '/orders/statistics', moduleKey: 'orders_statistics' },
            { titleKey: 'nav.marketingReport', to: '/orders/marketing', moduleKey: 'orders' },
        ],
    },
    // Emails and tracking — section (same routes as before; only the menu grouping moved)
    {
        titleKey: 'nav.emailsAndTracking',
        iconStyle: SVGICON.MailIcon,
        content: [
            { titleKey: 'nav.emailSendingSettings', to: '/settings/email-sending', moduleKey: 'settings' },
            { titleKey: 'nav.emailTemplates', to: '/settings/email-templates', moduleKey: 'settings' },
            { titleKey: 'nav.internalAlerts', to: '/settings/internal-alerts', moduleKey: 'settings' },
            { titleKey: 'nav.telegramAlerts', to: '/settings/telegram-alerts', moduleKey: 'settings' },
            { titleKey: 'nav.tracking', to: '/settings/tracking', moduleKey: 'tracking' },
        ],
    },
    // Finance — section (same routes and permissions as before; only the menu grouping moved)
    {
        titleKey: 'nav.finance',
        iconStyle: SVGICON.Doller,
        content: [
            { titleKey: 'nav.expenses', to: '/expenses', moduleKey: 'expenses' },
            { titleKey: 'nav.invoices', to: '/invoices', moduleKey: 'invoices' },
            { titleKey: 'nav.invoicingAccounting', to: '/settings/invoicing', moduleKey: 'settings' },
            { titleKey: 'nav.rompslomp', to: '/settings/rompslomp', moduleKey: 'settings' },
        ],
    },
    // Suppliers — section
    {
        titleKey: 'nav.suppliers',
        iconStyle: SVGICON.Table,
        content: [
            { titleKey: 'nav.suppliers', to: '/suppliers', moduleKey: 'suppliers' },
            { titleKey: 'nav.supplierAnalysis', to: '/suppliers-analysis', moduleKey: 'suppliers_analysis' },
        ],
    },
    // Users — section
    {
        titleKey: 'nav.users',
        iconStyle: SVGICON.UserSvg,
        content: [
            { titleKey: 'nav.users', to: '/users', moduleKey: 'users' },
            { titleKey: 'nav.userLogs', to: '/users-logs', moduleKey: 'user_logs' },
        ],
    },
];
